import { render } from "./LocalLoader.vue?vue&type=template&id=122fb080&scoped=true"
import script from "./LocalLoader.vue?vue&type=script&lang=js"
export * from "./LocalLoader.vue?vue&type=script&lang=js"

import "./LocalLoader.vue?vue&type=style&index=0&id=122fb080&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-122fb080"]])

export default __exports__